// src/Pages/WO/Components/forms/customComponents/RSCSLogo.jsx
import { useState } from 'react';
import { Box } from '@mui/material';
import { getLogoUrl } from 'src/Common/common';

// Company logo block for the WO form builder. Renders the *current company's*
// uploaded logo (public/<company>/company/logo.png) rather than a hardcoded
// one, so every tenant's forms show their own logo. If the company has no logo
// uploaded, the image fails to load and is hidden.
const RSCSLogo = ({
  width = 140,
  height = 'auto',
  alt = 'Company Logo',
  sx = {},
  ...rest
}) => {
  const [hidden, setHidden] = useState(false);

  return (
    <Box
      {...rest}
      sx={{
        width,
        height,
        minHeight: height === 'auto' ? 80 : undefined,
        display: 'grid',
        placeItems: 'center',
        alignSelf: 'center',
        my: 'auto',
        overflow: 'hidden',
      }}
    >
      {!hidden && (
        <Box
          component="img"
          src={getLogoUrl()}
          alt={alt}
          onError={() => setHidden(true)}
          sx={{
            width: 'auto',
            height: 'auto',
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
            objectPosition: 'center center',
            display: 'block',
            ...sx,
          }}
        />
      )}
    </Box>
  );
};

export default RSCSLogo;
